import { IPixelCustomDataParameters } from '@faire/web-api--source/indigofair/data/IPixelCustomDataParameters';
import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web/common/pete/TraceEventTracker';

export const eventKey =
  'open_with_faire-open_with_faire_application_submit-submit';

/**
 * Event that triggers on open with faire application submitted. Sent to Facebook through Pixel and CAPI.
 */
export function trackOpenWithFaireOpenWithFaireApplicationSubmitSubmit(
  pixelCustomDataParams?: IPixelCustomDataParameters
): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
    facebookPixelEvent: 'OwFApplication',
    pixelCustomDataParams,
  });
}
